import React, { useState, useEffect } from "react";
import * as Mui from "@mui/material";
import {
  administrationList,
  administrationCard,
  themes,
  headerMessage,
} from "services/constants";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { useSelector, useDispatch } from "react-redux";
import { showToast } from "services/utils/Status";
import { List, CreditCard } from "@mui/icons-material";
import { EditDepartment } from "./EditDepartment";
import { ListView } from "./ListView";
import { DialogBox } from "./DialogBox";
import { CardView } from "./CardView";
import { AddDepartment } from "./AddDepartment";
import { setDepartmentViewMethod } from "services/Redux/userToken";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { customAPI, customGetAPI } from "services/utils/CustomAPI";
import { tooltipStyleProps } from "services/constants/Styles";

export const Departments = () => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const [open, setOpen] = useState(false);
  const {
    token,
    domain,
    departmentViewMethod,
    globalSearchValue,
    userScreenAccess,
  } = useSelector((state) => state.tokenReducer);
  const dispatch = useDispatch();
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentApi, setDepartmentApi] = useState(true);
  const [userDataViewMethod, setUserDataViewMethod] =
    useState(departmentViewMethod);
  const [suspandPopup, setSuspandPopup] = useState(false);
  const [callSuspandApi, setCallSuspandApi] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentEditDepartmentDetails, setCurrentEditDepartmentDetails] =
    useState({});
  const [openEditScreen, setOpenEditScreen] = useState(false);
  const [editDepartmentDetails, setEditDepartmentDetails] = useState([]);
  const [page, setPage] = useState(0);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Departments",
    "Department"
  );

  const handleOpenDepartment = () => {
    setOpen(true);
  };

  useEffect(() => {
    setCurrentEditDepartmentDetails(""); //remove this line later
    const fetchTeam = async () => {
      setIsLoading(true);
      const res = await customGetAPI(
        `${domain}get_leads_based_on_departments/?company_id=${requestCompanyId}`
      );
      if (res.ok) {
        let data = res?.responseDetails?.filter((data) => {
          return data.department_name !== "All";
        });
        setMasterDataForSearch(data);
        setDepartmentList(data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    };
    if (departmentApi) {
      fetchTeam();
      setDepartmentApi(false);
    }
  }, [departmentApi, domain, token, requestCompanyId]);

  const handleClose = () => {
    setSuspandPopup(false);
  };

  useEffect(() => {
    const updateTeamSuspend = async () => {
      const response = await customAPI(`${domain}suspend_department/`, "PUT", {
        department_id: currentEditDepartmentDetails.department_id,
        department_lead_id: currentEditDepartmentDetails.department_lead_id,
      });
      if (response.ok) {
        showToast("success", "Department suspended.");
        setDepartmentApi(false);
        setSuspandPopup(false);
      }
    };
    if (callSuspandApi) {
      updateTeamSuspend();
      setCallSuspandApi(false);
    }
  }, [
    callSuspandApi,
    currentEditDepartmentDetails.department_id,
    currentEditDepartmentDetails.department_lead_id,
    domain,
    setCallSuspandApi,
    setSuspandPopup,
    token,
  ]);

  useEffect(() => {
    let filterKeys =
      userDataViewMethod === "CardView"
        ? administrationCard
        : administrationList;
    const filteredResults = masterDataForSearch.filter((item) =>
      filterKeys.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setDepartmentList(filteredResults);
    setPage(globalSearchValue ? 0 : page);
  }, [globalSearchValue, masterDataForSearch, page, userDataViewMethod]);

  return (
    <React.Fragment>
      {open ? (
        openEditScreen ? null : (
          <AddDepartment
            setOpen={setOpen}
            setDepartmentApi={setDepartmentApi}
          />
        )
      ) : null}
      {openEditScreen ? (
        <EditDepartment
          setOpenEditScreen={setOpenEditScreen}
          editDepartmentDetails={editDepartmentDetails}
          setDepartmentApi={setDepartmentApi}
        />
      ) : open ? null : (
        <Mui.Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          {headerMessage(
            "Departments",
            "Manage departments and their assigned department leads"
          )}
          <Mui.Stack direction="row" alignItems="center">
            <Mui.IconButton
              onClick={() => {
                dispatch(
                  setDepartmentViewMethod(
                    userDataViewMethod === "ListView"
                      ? "CardView"
                      : "ListView"
                  )
                );
                setUserDataViewMethod(
                  userDataViewMethod === "ListView" ? "CardView" : "ListView"
                );
              }}
            >
              <Mui.Tooltip
                arrow
                slotProps={tooltipStyleProps}
                key={userDataViewMethod}
                title={
                  userDataViewMethod === "CardView" ? "ListView" : "CardView"
                }
                placement="bottom"
              >
                {userDataViewMethod === "CardView" ? (
                  <List
                    style={{
                      fontSize: 35,
                      color: "#7D7D7D",
                      fontWeight: "bold",
                    }}
                  />
                ) : (
                  <CreditCard
                    style={{
                      fontSize: 35,
                      color: "#7D7D7D",
                      fontWeight: "bold",
                    }}
                  />
                )}
              </Mui.Tooltip>
            </Mui.IconButton>
            <CustomButton
              actionFuntion={() => {
                if (check_access) {
                  handleOpenDepartment();
                } else {
                  showToast(
                    "error",
                    "Access denied: You are not authorized to add department"
                  );
                }
              }}
              actionName="Add Department"
              typeName="button"
            />
          </Mui.Stack>
        </Mui.Box>
      )}
      {userDataViewMethod === "ListView" ? (
        openEditScreen || open ? null : (
          <ListView
            departmentList={departmentList}
            setCurrentEditDepartmentDetails={setCurrentEditDepartmentDetails}
            setSuspandPopup={setSuspandPopup}
            isLoading={isLoading}
            page={page}
            setPage={setPage}
            setOpenEditScreen={setOpenEditScreen}
            setEditDepartmentDetails={setEditDepartmentDetails}
            setDepartmentApi={setDepartmentApi}
            check_access={check_access}
            masterDataForSearch={masterDataForSearch}
          />
        )
      ) : openEditScreen || open ? null : (
        <CardView
          departmentList={departmentList}
          setCurrentEditDepartmentDetails={setCurrentEditDepartmentDetails}
          setSuspandPopup={setSuspandPopup}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          userDataViewMethod={userDataViewMethod}
          setOpenEditScreen={setOpenEditScreen}
          setEditDepartmentDetails={setEditDepartmentDetails}
          setDepartmentApi={setDepartmentApi}
          check_access={check_access}
          masterDataForSearch={masterDataForSearch}
        />
      )}
      <DialogBox
        open={suspandPopup}
        handleClose={handleClose}
        title="Team suspend"
      >
        <Mui.Typography style={{ fontSize: 20, padding: 5 }}>
          Do You want to Suspend this Department?
        </Mui.Typography>
        <Mui.Grid container>
          <Mui.Grid item xs={5}></Mui.Grid>
          <Mui.Grid item xs={3.5} sx={{ padding: 1 }}>
            <Mui.Button
              sx={{
                background: themes.btnBackgroundColor,
                width: "100%",
                tableLayout: "fixed",
                borderCollapse: "collapse",
              }}
              variant="contained"
              onClick={handleClose}
            >
              Cancel
            </Mui.Button>
          </Mui.Grid>
          <Mui.Grid item xs={3.5} sx={{ padding: 1 }}>
            <Mui.Button
              sx={{
                background: themes.btnBackgroundColor,
                width: "100%",
                tableLayout: "fixed",
                borderCollapse: "collapse",
              }}
              variant="contained"
              type="submit"
              onClick={() => setCallSuspandApi(true)}
            >
              Suspend
            </Mui.Button>
          </Mui.Grid>
        </Mui.Grid>
      </DialogBox>
    </React.Fragment>
  );
};
